import { Tooltip as TooltipPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const TooltipTrigger = (props: ComponentProps<typeof TooltipPrimitive.Trigger>) => (
  <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
);
